import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import image2 from "../images/trees.png"
import image1 from "../images/1mile.png"
import image3 from "../images/babybemine.png"
import Item from "../components/Item"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h2>Projects</h2>
    <p>A curated list of projects I have worked on</p>
    <Item 
      title="One Mile With a Smile" 
      lang="Laravel, React, React-Router, Stripe Api, sass, html, mysql" 
      image={image1}
      link="https://1milewithasmile.com" />

    <Item 
      title="Atlas Tree Service" 
      lang="Laravel, Vue, Sass, html, mysql, Stripe Api" 
      image={image2}
      link="https://atlastrees.net" />

    <Item 
      title="Baby Be Mines" 
      lang="Shopify, Sass, html, liquid, javascript" 
      image={image3}
      link="https://www.babybeminematernity.com" />
  </Layout>
)

export default IndexPage
